import React, {ReactElement} from 'react';
import {Dimmer, Loader, LoaderProps} from 'semantic-ui-react';
import {CenteredContent} from '../CenteredContent';

type TLoadingScreenProps = LoaderProps;

export const LoadingScreen = ({size = 'large', ...props}: TLoadingScreenProps): ReactElement => {
  return (
    <CenteredContent>
      <Dimmer active inverted>
        <Loader active size={size} {...props} />
      </Dimmer>
    </CenteredContent>
  );
};
